import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

const API = process.env.REACT_APP_BACKEND_URL;

function getSessionId() {
  let sid = sessionStorage.getItem('txr_sid');
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem('txr_sid', sid);
  }
  return sid;
}

export function usePageTracking(userId) {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    const key = location.pathname;
    if (key === lastTracked.current) return;
    lastTracked.current = key;

    // PostHog page view
    posthog.capture('$pageview', { $current_url: window.location.href });

    // Identify user if logged in
    if (userId) {
      posthog.identify(userId);
    }

    // Existing internal analytics
    const payload = {
      event_type: 'pageview',
      page: location.pathname,
      referrer: document.referrer,
      session_id: getSessionId(),
    };
    if (userId) payload.user_id = userId;

    fetch(`${API}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});
  }, [location.pathname, userId]);
}
